export function Amenity({ amenity, amenities, negative }) {

    const active = amenities.filter((item) => amenity == item).length > 0;

    const check =  (<div className="icon-holder icon-holder--green check"><div className="icon"></div></div>);
    const normal = (<div className="icon-holder icon-holder--grey check"><div className="icon"></div></div>);

    let icon = active ? check :normal;

    if(negative) {
        icon = (<div className="icon-holder icon-holder--red x"><div className="icon"></div></div>);
    }
    return(
        <div className="rentals-section__card__tag">{ icon } { amenity }</div>
    );
}